module.exports = __webpack_public_path__ + "media/images/favicon-2f7c27a7bcc8f7189d567b298b75c23b.png";